module.exports = {"markup":"<span class=\"inline-star inline-icon\"><svg width=\"14\" height=\"13\" viewBox=\"0 0 14 13\"><path d=\"M0 5.2l3.7 2.8-1.4 4.6.5.4 3.7-2.8 3.7 2.8.5-.4-1.4-4.6 3.7-2.8-.2-.6h-4.6l-1.4-4.6h-.6l-1.4 4.6h-4.6l-.2.6z\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./static/src/inline-svgs/icon/star.svg
// module id = 338
// module chunks = 5 15